// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_078a9d18","outerContainer":"a3d4ea06","secondaryToolbar":"_1943aaa5","doorHangerRight":"e9d4cf2d","toolbarContainer":"b96ac786","toolbarViewerMiddle":"_21793d68","progressBar":"f6e41f01","back-to-application":"_5b429a16","wrapper":"c7621031","infoWrapper":"c373dfd7","pointer":"bdae9707","info":"_542530dc","icon":"f6720f75","title":"aaabbaf0","titleAccent":"_484ee0ae","subtitle":"_93d373b5","removeIcon":"_47471f24"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/DocumentView/index.styl
// module id = 5199
// module chunks = 39